import { selectSingleFieldOnMap } from 'app/containers/Map/slice/selectors';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as L from 'leaflet';
import { useFieldSlice } from 'app/containers/Field/slice';
import { useMapSlice } from 'app/containers/Map/slice';

const useSetInitialEditFieldData = ({
  fieldIdInParams,
}: {
  fieldIdInParams: string;
}) => {
  const dispatch = useDispatch();
  const mappedField = useSelector(selectSingleFieldOnMap);
  const fieldActions = useFieldSlice().actions;
  const mapActions = useMapSlice().actions;

  const [isInitialDataSet, setIsInitialDataSet] = useState(false);

  useEffect(() => {
    dispatch(mapActions.setSingleFieldOnMapFieldId(Number(fieldIdInParams)));
  }, [mapActions, dispatch, fieldIdInParams]);

  useEffect(() => {
    if (mappedField && !isInitialDataSet) {
      setIsInitialDataSet(true);

      const polygon = L.polygon(mappedField.coordinates);
      const latlngs = polygon.getLatLngs();

      dispatch(
        fieldActions.setEditFieldData({
          name: mappedField.fieldParameters.name,
          latlngs,
          fieldId: mappedField.fieldParameters.fieldId,
          companyId: mappedField.fieldParameters.companyId,
          seasonId: mappedField.fieldParameters.seasonId,
        }),
      );
    }
  }, [mappedField, dispatch, fieldActions, isInitialDataSet]);

  return null;
};

export default useSetInitialEditFieldData;
